import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmergencyinfoService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();
  excelContent: any;

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }


  sendData(data: string) {
    this.dataSubject.next(data);
  }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  getEmergencyInfoList(parkID): Observable<any> {
    return this.apiService.get(`${APIs.getEmergencyInfoList}?parkId=${parkID}`).pipe(map(response => {
      return response;
    }));
  }

  removeEmergencyInfo(id: string): Observable<any> {
    return this.apiService.delete(APIs.removeEmergencyInfoList + '?emergencyInfoId=' + id).pipe(map(response => {
      return response;
    }));
  }

}
